// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { css } from "glamor";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import Link from "gatsby-link";
import { Image } from "@bodhi-project/components";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import logoBw from "../assets/logo.png";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
const { Fragment } = React;

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Desktop
const mobileNavStyles = css({
  height: "inherit",
  backgroundImage: "linear-gradient(to top, #dfe9f3 0%, white 100%)",
  padding: "0em",

  "& h4.outline, .outline": {
    display: "none",
  },

  "& a": {
    color: "#1d3e62 !important",
    borderBottom: "1.625px solid transparent !important",

    "&:hover": {
      color: "#FF7693 !important",
      borderBottom: "1.625px solid transparent !important",
    },
    "&:visited": {
      textDecoration: "none",
    },
    "&:link": {
      textDecoration: "none",
    },
    "&:active": {
      textDecoration: "none",
    },
  },

  "& ul": {
    listStyle: "none",
    padding: 0,

    "& li": {
      padding: "0em 1em",

      "&:nth-child(1)": {
        padding: "9px 1em 9px 1em",
        marginBottom: 0,
        boxShadow: "0px 3px 5px 0px rgba(30,30,30,0.2)",

        "& a": {
          display: "flex",
          alignItems: "center",
          marginBottom: 0,
        },
      },

      "&:nth-child(2)": {
        marginTop: "30px !important",
      },

      "& a": {
        display: "block",
        fontSize: "150%",
        marginBottom: "1em",
      },
    },
  },
});
const mobileNavStylesClass = mobileNavStyles.toString();

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** MobileNav */
class MobileNav extends React.Component {
  /** standard constructor */
  constructor(props) {
    super(props);
  }

  /** standard renderer */
  render() {
    return (
      <div className={mobileNavStylesClass}>
        <h4 className="nocontent outline">Mobile Navigation</h4>
        <ul>
          <li>
            <Link to="/">
              <div>
                <Image
                  src={logoBw}
                  style={{
                    height: 45,
                    width: 100,
                    border: "none",
                    background: "transparent",
                    marginRight: 8,
                  }}
                />
              </div>
              <strong>{this.props.menu.title}</strong>
            </Link>
          </li>
          <Fragment>
            {_.map(this.props.menu.menu, menuItem => {
              const { title, link } = menuItem;
              return (
                <li>
                  <Link to={link}>{title}</Link>
                </li>
              );
            })}
          </Fragment>
          
        </ul>
      </div>
    );
  }
}

MobileNav.propTypes = {
  menu: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

// --------------------------------------------------------------------- Export
export default MobileNav;



// WEBPACK FOOTER //
// ./src/blocks/MobileNav.jsx